import { Pipe, PipeTransform, Inject, LOCALE_ID } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
  name: "localeDate",
  standalone: false
})
export class LocaleDatePipe implements PipeTransform {
  locale: string = navigator.language;
  uSFormatTime: Intl.DateTimeFormatOptions = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
    hour12: true
  };

  /**
   *
   * @param value The date value to be displayed
   * @param args any template argument that the core DatePipe can use
   */
  transform(value: Date, args?: any, localOrUtc?: boolean): any {
    if (value === null) {
      return value;
    }
    if (!(value instanceof Date)) {
      console.log("Date type error please validate your input data");
    } else {
      const localeTime: Date = new Date();
      localeTime.setTime(
        value.getTime()
         - new Date().getTimezoneOffset() * 1 * 60000
      );
      const datePipe1 = new DatePipe("en-us");
      if (!args) {
        args = "short";
      }
      const datestring = datePipe1.transform(localeTime, args, undefined, "en-us").split(`/`);

      switch (navigator.language.toLowerCase()) {
        case "en-us":
          return datestring.join(`/`);

        default:
          if (datestring.length > 2) {
            const tempvar = datestring[0];
            datestring[0] = datestring[1];
            datestring[1] = tempvar;
          }
          return datestring.join(`/`);
      }
    }
  }
}
